/**
 * Persists cookie-banner analytics choices to the user's account (learning_analytics_consent).
 * Keeps banner localStorage and account settings in sync for logged-in users.
 */
import supabase from './supabase-client';
const LEARNING_ANALYTICS_CONSENT_TEXT = 'I consent to optional learning analytics telemetry (such as interaction timing and text-editing metrics) ' +
    'being processed to improve my study recommendations and tutor dashboards. I can turn this off at any time.';
export async function persistBannerAnalyticsConsent(user, granted) {
    const { error: consentError } = await supabase.from('consent_records').upsert({
        user_id: user.id,
        consent_type: 'learning_analytics_consent',
        consent_status: granted ? 'granted' : 'withdrawn',
        legal_basis: granted ? 'consent' : 'withdrawn',
        consent_text: LEARNING_ANALYTICS_CONSENT_TEXT,
        consent_version: '1.0',
        granted_at: granted ? new Date().toISOString() : null,
        withdrawn_at: granted ? null : new Date().toISOString(),
    });
    if (consentError)
        throw consentError;
    const tableName = user.role === 'student' ? 'students' : 'tutors';
    const { error: profileError } = await supabase
        .from(tableName)
        .update({
        learning_analytics_consent: granted,
        last_privacy_notice_at: new Date().toISOString(),
    })
        .eq('id', user.id);
    if (profileError)
        throw profileError;
}
